import { Box } from '@frontend/legacy-components';

import { NOTIFICATION_TYPES } from '../data/constants';
import NotificationComponent from './NotificationComponent';

const NotificationWrapper = ({ extraStyles, children }) => (
  <Box
    borderBottom="1px solid"
    borderBottomColor="separator.divider"
    {...extraStyles}
    _last={{
      borderBottom: 'none',
      ...extraStyles?._last,
    }}
  >
    {children}
  </Box>
);

const processNotificaiton = (notification) => {
  switch (notification.type) {
    case NOTIFICATION_TYPES.ASSIGNED_TO_ACTION:
    case NOTIFICATION_TYPES.BANK_VERIFICATION:
    case NOTIFICATION_TYPES.CHANNEL_MENTION:
    case NOTIFICATION_TYPES.DIGIQUOTE_VIEW:
    case NOTIFICATION_TYPES.ESTIMATOR_ASSIGNMENT:
    case NOTIFICATION_TYPES.MANUAL_INPUT_COMPLETED:
    case NOTIFICATION_TYPES.NEW_QUOTE_FROM_EMAIL:
    case NOTIFICATION_TYPES.NEW_RFQ:
    case NOTIFICATION_TYPES.NEW_SUBQUOTE:
    case NOTIFICATION_TYPES.SHARE_REINITIALIZATION_REQUEST:
    case NOTIFICATION_TYPES.THREAD_MENTION:
      return (
        <NotificationComponent
          key={notification.id}
          notification={notification}
        />
      );
    case NOTIFICATION_TYPES.CHANNEL_EVENT:
    case NOTIFICATION_TYPES.INTEGRATION_ACTION_FAILURE:
      return (
        <NotificationComponent
          key={notification.id}
          notification={notification}
          otherOccurrence="event"
          otherOccurrences="events"
        />
      );
    case NOTIFICATION_TYPES.CHANNEL_REPLY:
    case NOTIFICATION_TYPES.CHAT_REPLY:
    case NOTIFICATION_TYPES.TASKS:
    case NOTIFICATION_TYPES.PARTBOT_REPLY:
      return (
        <NotificationComponent
          key={notification.id}
          notification={notification}
          otherOccurrence="reply"
          otherOccurrences="replies"
        />
      );
    default:
      return null;
  }
};

const NotificationFactory = ({ notification, extraStyles }) => {
  return (
    <NotificationWrapper extraStyles={extraStyles}>
      {processNotificaiton(notification)}
    </NotificationWrapper>
  );
};

export default NotificationFactory;
